import React, {
  useContext, useEffect, useMemo, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../../../../Common/DataTable';
import { LocalizationContext } from '../../../../Common/Localization/LocalizationProvider';
import { RootState } from '../../../../redux/rootState';
import { PayloadTypeUnlinkSmc, SMCSubscribedCustomerData } from '../../Utils/TypeSmc';
import { getSmcCustomerListStart, unlinkSmcCustomer } from '../../Redux/sliceAddSmc';
import UnlinkComponentModal from '../../../../Common/UnlinkComponentModal/UnlinkComponentModal';
import { stripCustPrefix } from '../../../../utils/CommonFunctions';
import { defaultPageSize } from '../../../../utils/Constant';

function SubscribedCustomer() {
  const { smcCustomerList, smcId, totalSubscribedCustomers } = useSelector((state:RootState) => state?.addSmcDetailsReducer);
  const { translations } = useContext(LocalizationContext);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');
  const [selectedCustomerId, setSelectedCustomerId] = useState('');
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  const handleData = () => {
    const params = {
      page,
      rowsPerPage,
      smcId: String(smcId),
      searchQuery,
      sortCol,
      sortDir,
    };
    if (params.smcId) {
      dispatch(getSmcCustomerListStart(params));
    }
  };
  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortCol, sortDir]);

  const columns = useMemo(
    () => [
      // { key: 'sn', label: translations.sn },
      { key: 'action', label: translations.action },
      { key: 'markUp', label: translations.markup },
      { key: 'cust', label: translations.CustHash },
      { key: 'customer', label: translations.customer },
      { key: 'address', label: translations.address },
      { key: 'city', label: translations.city },
      { key: 'state', label: translations.state },
      { key: 'phone', label: translations.phone },
    ],
    [],
  );

  const handleLinkOff = (CustomerId: string) => {
    setShowModal(true);
    setSelectedCustomerId(CustomerId);
  };

  const handleDeleteData = () => {
    const payload:PayloadTypeUnlinkSmc = {
      SmcId: smcId,
      CustomerId: selectedCustomerId,
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
    };
    setShowModal(false);
    dispatch(unlinkSmcCustomer(payload));
  };

  const data: SMCSubscribedCustomerData[] = useMemo(() => smcCustomerList?.map((item, index) => {
    const transformedDataItem = {
      sn: index,
      action: 'linkOff',
      markUp: item?.Markup,
      cust: stripCustPrefix(item?.Custid),
      customer: item?.Customername,
      address: item?.Address,
      city: item?.CityName,
      state: item?.StateName,
      phone: item?.Phone,
      id: item?.Custid,
      customerId: item?.Custid,
    };
    return transformedDataItem;
  }), [smcCustomerList]);

  return (
    <>
      <DataTable<SMCSubscribedCustomerData>
        data={data}
        columns={columns}
        totalRecords={totalSubscribedCustomers}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        searchQuery={searchQuery}
        setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
        sortCol={sortCol}
        setSortCol={(e) => { setSortCol(e); setPage(1); }}
        sortDir={sortDir}
        setSortDir={(e) => { setSortDir(e); setPage(1); }}
        handleData={handleData}
        handleLinkOff={handleLinkOff}
        handleDataFromComponent
      />

      <UnlinkComponentModal
        show={showModal}
        setOpenFrom={() => setShowModal(false)}
        handleUnlink={handleDeleteData}
      />
    </>

  );
}

export default SubscribedCustomer;
